import MapView from "./MapView.vue"

const base = "/map"

export default [
    {
        path: base,
        name: "mapview",
        component: MapView,
        props: (route: any) => ({ locations: route.params.locations, centerLocation: route.params.centerLocation })
    }
]
